import { Action } from '@ngrx/store';
import {
  TableQueryParams,
} from '../../layout/main/main.model';
import { DeviceCommandScheduleInterface } from './device-command-schedule.model';
import { CustomDeviceManagementFilterOutputInterface } from '../../view/device-management/device-management.model';

export enum DeviceActionTypes {
  GetDeviceCommandSchedules = '[Device] Get Command Schedules',
  GetDeviceCommandSchedulesCompleted = '[Device] Get Device Command Schedules Completed',
  DeleteDeviceCommandSchedule = '[Device] Delete Device Command Schedule',
  DeleteDeviceCommandScheduleCompleted = '[Device] Delete Device Command Schedule Completed',
  ClearState = '[Device] Clear State',
  FetchError = '[Device] Fetch Error',
}

export class GetDeviceCommandSchedules implements Action {
  readonly type = DeviceActionTypes.GetDeviceCommandSchedules;

  constructor(
    public filters: CustomDeviceManagementFilterOutputInterface,
    public query: TableQueryParams = {
      page: 1,
      pageSize: 10,
    },
    public timezone: string,
  ) {}
}


export class GetDeviceCommandSchedulesCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceCommandSchedulesCompleted;

  constructor(public messageList: DeviceCommandScheduleInterface[], public itemTotal: number) {}
}

export class DeleteDeviceCommandSchedule implements Action {
  readonly type = DeviceActionTypes.DeleteDeviceCommandSchedule;
  constructor(public id: number) {}
}

export class DeleteDeviceCommandScheduleCompleted implements Action {
  readonly type = DeviceActionTypes.DeleteDeviceCommandScheduleCompleted;

  constructor(public id: number, public response: any) {}
}

export class ClearState implements Action {
  readonly type = DeviceActionTypes.ClearState;
}

export class FetchError implements Action {
  readonly type = DeviceActionTypes.FetchError;

  constructor(public payload: any[]) {}
}

export type DeviceCommandScheduleActions =
  | GetDeviceCommandSchedules
  | GetDeviceCommandSchedulesCompleted
  | ClearState
  | FetchError;
